import {
  type Category,
  CategorySelect,
  CategorySelectContextProvider,
  ScheduleCategoryDataProvider,
} from '@/pages/Schedule/components';
import { getEntryCategoryColors } from '@/pages/Schedule/utils';
import { Menu, type MenuButtonProps, MenuList } from '@/ui';
import { DefaultsMenuButton } from './DefaultsMenuButton';

type Props = Omit<MenuButtonProps, 'onSelect'> & {
  selected: Category | null;
  onSelect: (category: Category | null) => void;
};

export const CategoryPicker = ({ selected, onSelect }: Props) => {
  const categoryColors = getEntryCategoryColors(selected?.color);

  return (
    <ScheduleCategoryDataProvider>
      <CategorySelectContextProvider>
        <Menu isLazy>
          {({ onClose }) => (
            <>
              <DefaultsMenuButton
                _active={{ bg: categoryColors.hoverBackgroundColor }}
                _hover={{ bg: categoryColors.hoverBackgroundColor }}
                bg={categoryColors.backgroundColor}
                borderRadius="4"
                color="customgray.dark"
                minW={{ base: '200px', sm: '300px' }}
                py="0"
                textAlign="left"
              >
                {selected?.text ?? <>&nbsp;</>}
              </DefaultsMenuButton>

              <MenuList minW="350px" p="0">
                <CategorySelect
                  selected={selected}
                  onClose={onClose}
                  onSelect={(category) => {
                    onSelect(category);
                    onClose();
                  }}
                />
              </MenuList>
            </>
          )}
        </Menu>
      </CategorySelectContextProvider>
    </ScheduleCategoryDataProvider>
  );
};
